import to from 'await-to-js'
import { toast } from 'react-toastify'
import { Modal } from '../../../components/UI/Modal/Modal'
import { Select } from '../../../components/UI/Select/Select'
import apiService from 'services/api'
import { toCalendarSelectItems } from 'services/calendarsApi'
import { useCalendars } from './useCalendars'

interface SelectCalendarModalProps {
  open: boolean
  integrationId: number | null
  onClose: () => void
  onSelected: () => void
}

export function SelectCalendarModal({
  open,
  integrationId,
  onClose,
  onSelected,
}: SelectCalendarModalProps) {
  const api = apiService()
  const { calendars, selectedId, setSelectedId, loading } = useCalendars(
    integrationId,
    open
  )

  const selectItems = toCalendarSelectItems(calendars)

  async function handleConfirm() {
    if (!integrationId || !selectedId) return
    const [err] = await to(
      api.calendars.selectCalendar(integrationId, selectedId)
    )
    if (err) {
      toast.error('Failed to select calendar')
      return
    }
    toast.success('Calendar selected')
    onSelected()
  }

  return (
    <Modal
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      title={
        <div className="flex flex-col gap-1">
          <span className="text-xs font-light tracking-[0.03em] text-fg">
            INTEGRATIONS
          </span>
          <span className="text-xl font-semibold text-fg leading-7">
            Select Calendar
          </span>
        </div>
      }
      description="Choose which calendar First Bite should use for this account."
      onAccept={handleConfirm}
      acceptButtonText="Confirm"
      blockAccept={!selectedId || loading}
      onCancel={onClose}
      cancelButtonText="Skip"
      loading={loading}
    >
      <div className="flex flex-col gap-4 py-2">
        <div className="flex flex-col gap-[6px]">
          <h3 className="text-sm font-medium text-fg leading-5">Calendar</h3>
          <Select<number>
            items={selectItems}
            selected={selectedId ?? undefined}
            onSelect={(val) => setSelectedId(val)}
            nullSelectionLabel="Select a calendar..."
            matchTriggerWidth
            buttonVariant="secondary"
          />
        </div>
      </div>
    </Modal>
  )
}
